export default "__VITE_ASSET__BHxIy5Uc__"